import * as React from 'react';
import { useSelector } from 'react-redux';

import { Footer } from '../../../components/AdvancedFiltersComponent/components/Footer';
import { selectIsProfessionalSearchPromoVisible, selectProfessionalSearchUrlWithFilters } from '../../../selectors';
import { trackProfessionalSearchClick } from './tracking';

export interface IAdvancedFiltersFooterContainerProps {
  onClearClick(): void;
  onShowClick(): void;
}

export const AdvancedFiltersFooterContainer = ({ onClearClick, onShowClick }: IAdvancedFiltersFooterContainerProps) => {
  const professionalSearchUrl = useSelector(selectProfessionalSearchUrlWithFilters);
  const isProfessionalSearchButtonVisible = useSelector(selectIsProfessionalSearchPromoVisible);

  const handleProfessionalSearchClick = React.useCallback(() => {
    trackProfessionalSearchClick();
  }, []);

  return (
    <Footer
      onClearClick={onClearClick}
      onShowClick={onShowClick}
      professionalSearchUrl={professionalSearchUrl}
      isProfessionalSearchButtonVisible={isProfessionalSearchButtonVisible}
      onProfessionalSearchClick={handleProfessionalSearchClick}
    />
  );
};
